import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=1d965d6f&"
import script from "./banner.vue?vue&type=script&lang=js&"
export * from "./banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d965d6f')) {
      api.createRecord('1d965d6f', component.options)
    } else {
      api.reload('1d965d6f', component.options)
    }
    module.hot.accept("./banner.vue?vue&type=template&id=1d965d6f&", function () {
      api.rerender('1d965d6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/banner.vue"
export default component.exports